import { j as H } from "./jsx-runtime-3tyXYecC.mjs";
import { A as j } from "./autocomplete-single-DLiRLl1T.mjs";
import { _ as y } from "./composeRefs-YONvD-rx.mjs";
import { D as M } from "./default-error-messages.constants-BvAz67KV.mjs";
import { g as O } from "./get-aria-describedby-G1wcWKF2.mjs";
import { u as T } from "./use-rhf-wrapper-controller-DGFm3TD5.mjs";
import { t as U } from "./toggle-rhf-rules-Z1TdwfO9.mjs";
import { a as B } from "./add-rhf-default-error-message-C9MkLfg3.mjs";
import { c as L } from "./combine-function-calls-C5qD-ZYI.mjs";
import { e as G } from "./extract-rhf-validation-rule-value-DyB3XAHu.mjs";
const P = window.jQuery ? $.__("Please select from the available options.") : "Please select from the available options.";
function Y({
  apiRef: c,
  ariaDescribedby: u,
  allowAnyInputValue: t,
  control: g,
  defaultValue: n = null,
  disabled: i,
  errorMessageId: l,
  name: E,
  onBlur: R,
  onChange: m,
  options: h,
  required: o = !1,
  shouldUnregister: _,
  status: A,
  validate: C,
  ...F
}) {
  var p;
  const { field: S, fieldState: a } = T({
    control: g,
    defaultValue: n,
    name: E,
    // This is a workaround for `disabled` because it is not available in `useController` yet (not available until v7.48.0).
    rules: U(
      {
        required: typeof o == "string" ? o : B(
          o,
          t ? M.required : P
        ),
        validate: C
      },
      i
    ),
    shouldUnregister: _
  }), { onChange: d, onBlur: D, ref: b } = S, f = (s, e) => {
    const { value: r } = s;
    d(r), typeof m == "function" && m(r, e == null ? void 0 : e.nativeEvent);
  }, v = (s, e) => {
    const { value: r, reason: x } = s;
    t && x === "input" && f({ reason: "selectOption", value: r === "" ? n : r }, e);
  };
  return /* @__PURE__ */ H.jsx(
    j,
    {
      ...F,
      allowAnyInputValue: t,
      apiRef: y(b, c),
      ariaDescribedby: O(a.error ? l : void 0, u),
      disabled: i,
      errorMessage: l || (p = a.error) == null ? void 0 : p.message,
      onBlur: L(D, R),
      onChange: f,
      onInputChange: v,
      options: h,
      required: typeof o == "string" ? !!o : G(o),
      status: a.error ? "error" : A
    }
  );
}
export {
  Y as A
};
//# sourceMappingURL=autocomplete-single-rhf-BGnWrBgA.mjs.map
